import {z} from "zod/v4-mini"
import type {FundamentalLikeNode} from "#template/role-markers"
import {createFundamentalMarker} from "#template/role-markers"

export const numberLikeMarker = Symbol("NumberLike")

export interface NumberLikeNode extends FundamentalLikeNode<number | null> {
    readonly [numberLikeMarker]: true
}

export const numberMarker = createFundamentalMarker<NumberLikeNode, number>(numberLikeMarker, {
    rawSchema: z.number(),
    acceptsRaw: (x): x is number => typeof x === "number",
})
export const {
    isLikeNode: isNumberLikeNode,
    isLikeNodeClass: isNumberLikeNodeClass,
    likeNode: numberLikeNode,
    isLike: isNumberLike,
    like: numberLike,
} = numberMarker
export type NumberLike = z.infer<typeof numberLike>
